import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, showNotification, refreshView as refreshViewAction } from 'react-admin';

import request from '../../../../network/request';
import resourceConfig from './config';

class OrderCloseReadyOrdersButton extends Component {
    state = {
      executing: false
    }
    handleClick = async() => {
        const { showNotification, refreshView } = this.props;

        this.setState({
          executing: true
        });
        let response = null;
        try {
          response = await request({
            apiService: 'shoes',
            path: '/admin/order/func/close_reade_order',
            method: 'POST',
          })
        } catch (e) {
          console.error(e);
        }
        if (response === null || !response.ok) {
          showNotification(`resources.${resourceConfig.name}.closeOrders.errorMessage`, 'error');
        } else {
          showNotification(`resources.${resourceConfig.name}.closeOrders.successMessage`, 'success');
        }
        
        this.setState({
          executing: false
        }, refreshView);
    };
    

    render() {
        return (
            <Button label={`resources.${resourceConfig.name}.closeOrders.action`} disabled={this.state.executing} onClick={this.handleClick} />
        );
    }
}

export default connect(undefined, { 
  showNotification,
  refreshView: refreshViewAction
})(OrderCloseReadyOrdersButton);